import { Dispatch, SetStateAction, useState } from 'react';
import { useEventCallback } from '../useEventCallback';

/**
 * a hook to control an opened state
 */
export function useOpened(): UseOpenedReturnValue {
  const [opened, setOpened] = useState(false);

  const close = useEventCallback(() => {
    setOpened(false);
  });

  const open = useEventCallback(() => {
    setOpened(true);
  });

  return {
    opened,
    setOpened,
    close,
    open
  };
}

export type UseOpenedReturnValue = {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  close: () => void;
  open: () => void;
};
